import { AppConfig } from '@superbet-group/web.lib.config';
import { PayoutService } from '@core/services/betSlip/PayoutService';
import { TaxService } from '@core/services/betSlip/TaxService';
import Singleton from '@core/services/common/Singleton';
import OfferService from '@core/services/offer/OfferService';
import StructService from '@core/services/offer/StructService';
import PushNotificationsService, { SignalRSocket } from '@core/services/pushNotifications/PushNotificationsService';
import ResultsService from '@core/services/results/ResultsService';
import { UserService } from '@core/services/user/UserService';
import SeoService from '../seo/SeoService';
import ZendeskService from '../zendesk/zendeskService';
import { StructManager } from '../offer/StructManager';

// TODO Ideally, each federation should take care of its own singletons,
// or they should be marked in some way that makes them auto-created,
// instead of having to deal with this in such a way
export function initializeSingletonInstances(config: AppConfig) {
    const configurableServices: Singleton<any>[] = [
        OfferService,
        StructService,
        ResultsService,
        StructManager,
        UserService,
        TaxService,
        PayoutService,
        SeoService,
        ZendeskService,
    ];

    if (config.user.arePushNotificationsEnabled && config.user.pushNotificationsUrl) {
        const notificationSocketService = new SignalRSocket(config.user.pushNotificationsUrl);
        PushNotificationsService.createInstance(config, notificationSocketService);
    }

    configurableServices.forEach((s) => {
        s.createInstance(config);
    });
}
